import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Contact } from 'ng2-app/models/dto/contact.model';

@Component({
  selector: 'app-additional-owners-smart',
  templateUrl: './additional-owners-smart.component.html',
  styleUrls: ['./additional-owners-smart.component.scss'],
  standalone: false
})
export class AdditionalOwnersSmartComponent implements OnInit {

  @Input() borrowerId: number;
  @Input() contacts: Contact[] = [];
  @Output() resendRequiredComplete = new EventEmitter<void>();
  @Output() resendPostOfferVerificationComplete = new EventEmitter<void>();

  constructor() { }

  ngOnInit() { }

  requiredComplete() {
    this.resendRequiredComplete.emit();
  }

  postOfferVerificationComplete() {
    this.resendPostOfferVerificationComplete.emit();
  }
}
